import "react-data-grid/lib/styles.css";
import "../components/DataTable/styles.css";
import { useEffect, useState } from "react";
import GridTable from "../components/Table";
import { useAppDispatch } from "../hooks/app";
import {
  getOrgnizationLicenseData,
  getOrgViewUsers,
} from "../redux/actions/orgnization";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import moment from "moment-timezone";

export const ViewOrganizationModal = ({ orgId }: { orgId: any }) => {
  const dispatch = useAppDispatch();
  const [limit, setLimit] = useState<any>(10);
  const [page, setPage] = useState<any>(1);
  const [licenseData, setLicenseData] = useState<any>([]);
  const [userData, setUserData] = useState<any>({
    users: [],
    totalCount: 0,
  });

  const orgLicenseDetails = useSelector(
    (state: RootState) => state.organization?.orgLicenseData
  );
  const orgUserDetails = useSelector(
    (state: RootState) => state.organization?.orgUserData
  );
  const [userPageLimit, setUserPageLimit] = useState<any>(10);
  const [userPageNo, setUserPageNo] = useState<any>(1);
  const [searchString, setSearchString] = useState<any>("");

  useEffect(() => {
    if (orgId) {
      dispatch(getOrgnizationLicenseData(orgId));
    }
  }, [orgId, dispatch]);

  useEffect(() => {
    const data: any = {
      page: userPageNo,
      limit: userPageLimit,
      searchParam: searchString ? searchString : "",
      orgId: orgId,
    };
    dispatch(getOrgViewUsers(data));
  }, [orgId, userPageNo, userPageLimit, searchString, dispatch]);

  useEffect(() => {
    setUserData({
      users: (orgUserDetails?.users || []).map((u: any) => ({
        ...u,
        full_name: `${u.firstName || ""} ${u.lastName || ""}`.trim(),
      })),
      totalCount: orgUserDetails?.totalCount || 0,
    });
  }, [orgUserDetails, userPageNo, userPageLimit, searchString, dispatch]);

  useEffect(() => {
    if (orgLicenseDetails?.license?.length) {
      const dataLicense = orgLicenseDetails?.license?.map((row: any) => {
        const appName = row?.application?.applicationName;
        const appCode = row?.application?.applicationCode;
        const startDate = moment(row.startDate).format("MM/DD/YYYY");
        const endDate = moment(row.expireDate).format("MM/DD/YYYY");
        return { ...row, appName, appCode, startDate, endDate };
      });
      setLicenseData(dataLicense);
    } else {
      setLicenseData([]);
    }
  }, [orgLicenseDetails, dispatch]);

  const column1: any = [
    {
      key: "appName",
      name: "Application Name",
      sortable: true,
      draggable: true,
    },
    {
      key: "appCode",
      name: "Application Code",
      sortable: true,
      draggable: true,
    },
    { key: "startDate", name: "Start Date", sortable: true, draggable: true },
    { key: "endDate", name: "End Date", sortable: true, draggable: true },
    { key: "license", name: "License", sortable: true, draggable: true },
  ];

  const column2: any = [
    { key: "full_name", name: "Name" },
    { key: "email", name: "Email" },
  ];

  return (
    <div>
      <div className="min-h-[300px]">
        <p className="text-[#264390] font-bold text-[20px] flex justify-center">
          License Details
        </p>
        <GridTable
          rowData={licenseData}
          columnData={column1}
          showAction={false}
          onPageChange={(pageNumber) => setPage(pageNumber)}
          onRowsPerPageChange={(limit) => setLimit(limit)}
          totalCount={licenseData?.length}
          hidePagination={true}
          hideSearch={true}
        />
      </div>

      <div>
        <p className="text-[#264390] font-bold text-[20px] mt-5 flex justify-center">
          User Details
        </p>
        <GridTable
          rowData={userData?.users}
          columnData={column2}
          showAction={false}
          onPageChange={(pageNumber) => setUserPageNo(pageNumber)}
          onRowsPerPageChange={(limit) => setUserPageLimit(limit)}
          totalCount={userData?.totalCount}
          hideSearch={true}
        />
      </div>
    </div>
  );
};
